import { InjectionToken } from '@angular/core';
import Medusa from '@medusajs/js-sdk';
import { environment } from '../../../../environments/environment';

// Angular creates a separate injector/client per SSR request. No global auth state.
export const MEDUSA_CLIENT = new InjectionToken<Medusa>('Medusa Store SDK', {
  providedIn: 'root',
  factory: () =>
    new Medusa({
      baseUrl: environment.storeApiUrl,
      publishableKey: environment.publishableKey,
      auth: { type: 'session' },
    }),
});

export const MEDUSA_REGION_ID = new InjectionToken<string>(
  'Medusa India region',
  {
    providedIn: 'root',
    factory: () => environment.regionId,
  },
);
